"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAutoCacheSwitch = addAutoCacheSwitch;
exports.deleteAutoCacheSwitch = deleteAutoCacheSwitch;
exports.getAutoCacheMetrics = getAutoCacheMetrics;
exports.getAutoCacheStatus = getAutoCacheStatus;
exports.getAutoCacheSwitches = getAutoCacheSwitches;
exports.setAutoCacheEnabled = setAutoCacheEnabled;
exports.setAutoCacheMode = setAutoCacheMode;
exports.setAutoCacheSwitch = setAutoCacheSwitch;
exports.unlockAllAutoCacheSwitch = unlockAllAutoCacheSwitch;
exports.unlockAutoCacheSwitch = unlockAutoCacheSwitch;
exports.updateAutoCacheSwitch = updateAutoCacheSwitch;
exports.updateAutoCacheThreshold = updateAutoCacheThreshold;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: liaoqiqing
// +----------------------------------------------------------------------

/**
 * 获取自动缓存开关状态总览
 */
function getAutoCacheStatus() {
  return (0, _request.default)({
    url: '/admin/system/auto-cache-switch/status',
    method: 'get'
  });
}

/**
 * 手动设置缓存开关状态
 * @param {string} cacheKey - 配置键名
 * @param {string} switchValue - 开关值，"1"=开，"0"=关
 */
function setAutoCacheSwitch(cacheKey, switchValue) {
  return (0, _request.default)({
    url: '/admin/system/auto-cache-switch/set',
    method: 'post',
    data: {
      cacheKey: cacheKey,
      switchValue: switchValue
    }
  });
}

/**
 * 切换运行模式
 * @param {string} mode - 模式值，"manual"=手动，"auto"=自动，"hybrid"=混合
 */
function setAutoCacheMode(mode) {
  return (0, _request.default)({
    url: '/admin/system/auto-cache-switch/mode',
    method: 'post',
    data: {
      mode: mode
    }
  });
}

/**
 * 解除指定开关的手动锁定
 * @param {string} cacheKey - 配置键名
 */
function unlockAutoCacheSwitch(cacheKey) {
  return (0, _request.default)({
    url: '/admin/system/auto-cache-switch/unlock',
    method: 'post',
    data: {
      cacheKey: cacheKey
    }
  });
}

/**
 * 解除所有手动锁定
 */
function unlockAllAutoCacheSwitch() {
  return (0, _request.default)({
    url: '/admin/system/auto-cache-switch/unlock-all',
    method: 'post'
  });
}

/**
 * 获取当前并发指标
 */
function getAutoCacheMetrics() {
  return (0, _request.default)({
    url: '/admin/system/auto-cache-switch/metrics',
    method: 'get'
  });
}

/**
 * 设置自动缓存功能总开关
 * @param {boolean} enabled - true=开启，false=关闭
 */
function setAutoCacheEnabled(enabled) {
  return (0, _request.default)({
    url: '/admin/system/auto-cache-switch/enable',
    method: 'post',
    data: {
      switchValue: enabled ? '1' : '0'
    }
  });
}

/**
 * 更新阈值配置
 * @param {object} thresholds - 阈值对象，可包含 qpsOnThreshold, qpsOffThreshold, userOnThreshold, userOffThreshold
 */
function updateAutoCacheThreshold(thresholds) {
  return (0, _request.default)({
    url: '/admin/system/auto-cache-switch/threshold',
    method: 'post',
    data: thresholds
  });
}

/**
 * 获取所有缓存开关配置
 */
function getAutoCacheSwitches() {
  return (0, _request.default)({
    url: '/admin/system/auto-cache-switch/switches',
    method: 'get'
  });
}

/**
 * 新增缓存开关
 * @param {object} data - { configKey, name, remark, sort }
 */
function addAutoCacheSwitch(data) {
  return (0, _request.default)({
    url: '/admin/system/auto-cache-switch/switches',
    method: 'post',
    data: data
  });
}

/**
 * 更新缓存开关
 * @param {object} data - { configKey, name, remark, sort }
 */
function updateAutoCacheSwitch(data) {
  return (0, _request.default)({
    url: '/admin/system/auto-cache-switch/switches',
    method: 'put',
    data: data
  });
}

/**
 * 删除缓存开关
 * @param {string} configKey - 配置键名
 */
function deleteAutoCacheSwitch(configKey) {
  return (0, _request.default)({
    url: "/admin/system/auto-cache-switch/switches/".concat(configKey),
    method: 'delete'
  });
}